module.exports = __webpack_public_path__ + "img/figure-4.6482ed72.png";